<template>
  <component
    :is="getComponentForType(cmsComponent.typeCode)"
    v-for="cmsComponent in cmsComponents"
    :key="cmsComponent.uid"
    :component-data="cmsComponentsData[cmsComponent.uid]"
  />
</template>

<script setup>
import {useCmsComponent} from '@/composables/cms-component.js';
import {computed} from 'vue';
import {useStore} from '@/store';
import {getComponentForType} from '@/modules/CmsComponentMapper.js';

const props = defineProps({
  slotPosition: {
    type: String,
    default: '',
  },
});

const store = useStore();

const userParams = computed(() => {
  return store.getters['backend/occUrlParams'].userId;
});

const cmsComponents = computed(() => {
  const slotData = store.getters['headlessCms/componentsBySlotPosition'](props.slotPosition);
  return slotData?.component || [];
});

const cmsComponentsData = computed(() => {
  let componentsData = {};
  if (!cmsComponents.value?.length) return componentsData;

  cmsComponents.value.forEach(function (cmsComponent) {
    componentsData[cmsComponent.uid] = {
      ...cmsComponent,
      ...useCmsComponent(userParams.value, cmsComponent.uid).componentData,
    };
  });
  return componentsData;
});
</script>
